module.exports = __webpack_public_path__ + "img/background-todos.5bb39ec7.png";